<script lang="ts">
    import { COMMANDS } from "$lib/commands";
    import { file, interaction, layers, frameIndex, layerIndex } from "$lib/state";
    import Preview from "$lib/image/Preview.svelte";
    import IconCommandButton from "$lib/utility/IconCommandButton.svelte";
    import Icon from "$lib/utility/Icon.svelte";

    function toggleVisibility(layer: number, current: boolean) {
        COMMANDS.invoke("edit.toggle-layer-visibility", layer, !current);
    }

    function rename() {
        COMMANDS.invoke("edit.rename-layer");
    }

    function removeLayer(layer: number) {
        COMMANDS.invoke("edit.remove-layer", layer);
    }

    function setActiveLayer(index: number) {
        $interaction.setLayer(index);
    }

    const activeDisplayOptions = { focus: false }; // todo

    function moveLayerUp(index: number) {
        COMMANDS.invoke("edit.move-layer-up-index", index);
    }

    function moveLayerDown(index: number) {
        COMMANDS.invoke("edit.move-layer-down-index", index);
    }
</script>

<!----------------------------------------------------------------------------->
<div class="buttons">
    <IconCommandButton command={COMMANDS.commands["edit.add-layer"]} icon="layers-add-24" tooltip="Add layer"/>
    <IconCommandButton command={COMMANDS.commands["edit.merge-layers"]} icon="layers-merge-24" tooltip="Merge layer down"/>
    <IconCommandButton command={COMMANDS.commands["edit.remove-layer"]} icon="layers-remove-24" tooltip="Remove layer" color="error-secondary"/>
</div>
<div class="layers" class:focus-mode={activeDisplayOptions.focus}>
    {#if $file && $frameIndex !== null}
    {#key $file.id}
        {#each [...($layers ?? [])].reverse() as layer, reverseIndex}
            {@const index = layer.index}
            {@const active = $layerIndex === index}
            <button class="layer" class:active on:click={() => setActiveLayer(index)}>
                <label class="visible" on:click|stopPropagation>
                    {#if activeDisplayOptions.focus}
                        <input type="checkbox" checked={active} disabled />
                    {:else}
                        <input type="checkbox" checked={layer.visible} on:change={() => toggleVisibility(index, layer.visible)} />
                    {/if}
                </label>

                <div class="preview">
                    <Preview file={$file} frame={$frameIndex} layer={index} />
                </div>

                {#if active}
                    <button class="name" on:click={() => rename()}>{layer.name}</button>
                {:else}
                    <span class="name">{layer.name}</span>
                {/if}

                <div class="move-layer" on:click|stopPropagation>
                    <IconCommandButton on:click={() => moveLayerUp(index)} iconOnly={true} icon="arrow-up-16" disabled={reverseIndex === 0}/>
                    <IconCommandButton on:click={() => moveLayerDown(index)} iconOnly={true} icon="arrow-down-16" disabled={reverseIndex === ($layers?.length ?? 1) - 1}/>
                </div>
<!--                <IconCommandButton on:click={(e) => {removeLayer(index); e.stopPropagation()}} icon="delete-16" color="error" tooltip="Delete layer" disabled={($layers?.length ?? 1) <= 1} />-->
            </button>
        {/each}
    {/key}
    {/if}
</div>

<!----------------------------------------------------------------------------->

<style>
    .buttons {
        display: flex;
        gap: 0.25em;
        padding: 0.25em;
        border-bottom: 1px solid var(--g50);
    }

    .layers {
        display: grid;
        grid-template-columns: max-content max-content 1fr max-content max-content 0.5em;
        grid-auto-rows: max-content;

        overflow-y: scroll;
        overflow-x: auto;
        height: 100%;
        width: 100%;
    }

    .layer {
        all: unset;
        display: grid;
        grid-template-columns: subgrid;
        grid-column: 1 / -1;
        align-items: center;

        user-select: none;
        box-sizing: border-box;
        border-bottom: 1px solid var(--gap-color);
    }

    .active {
        background: var(--g200);
    }

    .preview {
        position: relative;
        margin: 0.125em;
        height: 2.5em;
        width: 2.5em;

        & :global(canvas) {
            height: 2.5em;
            width: 2.5em;
            box-sizing: border-box;
            border: 1px solid var(--g100);
        }
    }

    .name {
        all: unset;
        display: block;
        padding: 0.25em;
        align-self: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    button.name {
        cursor: text;
    }

    .active .name {
        color: var(--tacc);
    }

    .visible {
        display: grid;
        place-content: center;
        width: 1.5em;
        height: 100%;
    }

    .focus-mode input[type="checkbox"]:checked {
        background-color: var(--gacc100);
        outline-color: var(--gacc200);
    }

    .move-layer {
        display: flex;
        flex-direction: column;
    }
</style>
